/**
 * 회사 소개 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Target, Users, Globe } from "lucide-react";

export default function About() {
  return (
    <>
      <Seo
        title="회사 소개 — OZK News"
        description="OZK News는 호주 한인 커뮤니티를 위한 종합 정보 플랫폼입니다."
        path="/about"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">회사 소개</h1>
            <p className="text-lg text-muted-foreground">
              호주 한인 커뮤니티를 위한 종합 정보 플랫폼
            </p>
          </div>

          <div className="space-y-8">
            {/* 회사 개요 */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Building2 className="w-5 h-5" />
                  회사 개요
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  OZK News는 호주에 거주하는 한인 커뮤니티를 위한 종합 정보 플랫폼입니다.
                  뉴스, 중고거래, 부동산, 구인구직, 커뮤니티 등 다양한 서비스를 한 곳에서 제공합니다.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                  <div>
                    <p className="font-semibold mb-2">회사명</p>
                    <p className="text-muted-foreground">MRT Robotics Pty Ltd</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">ABN</p>
                    <p className="text-muted-foreground">61 168 348 463</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">주소</p>
                    <p className="text-muted-foreground">160 Midson Road Epping NSW 2121</p>
                  </div>
                  <div>
                    <p className="font-semibold mb-2">연락처</p>
                    <p className="text-muted-foreground">
                      +61-450 760 790<br />
                      ozknews.com@gmail.com
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* 비전 */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Target className="w-5 h-5" />
                  비전
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  호주 한인 커뮤니티가 더욱 활발하게 소통하고 정보를 공유할 수 있는 플랫폼을 만들어
                  한인들의 호주 생활을 더욱 풍요롭게 만드는 것이 우리의 목표입니다.
                </p>
              </CardContent>
            </Card>

            {/* 서비스 */}
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Globe className="w-5 h-5" />
                  주요 서비스
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  <li>• 호주 한인 뉴스 및 정보 제공</li>
                  <li>• 중고거래 및 마켓플레이스</li>
                  <li>• 부동산 정보 및 거래</li>
                  <li>• 구인구직 정보</li>
                  <li>• 커뮤니티 및 동네톡톡</li>
                  <li>• 비즈니스 디렉토리</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

